/**
 * SWISA — mobile scroll-snap carousel with dot indicators.
 * Used by the Customer Stories section. Desktop shows a static grid, so this
 * only wires up when the track is actually scrollable.
 */
class SwisaCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-swisa-track]');
    this.dots = Array.from(this.querySelectorAll('[data-swisa-dot]'));
    if (!this.track) return;

    this.track.addEventListener('scroll', this.#onScroll, { passive: true });
    for (const dot of this.dots) {
      dot.addEventListener('click', () => {
        const slide = this.track.children[Number(dot.dataset.swisaDot)];
        if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      });
    }
    this.#onScroll();
  }

  #onScroll = () => {
    if (this.#raf) return;
    this.#raf = requestAnimationFrame(() => {
      this.#raf = 0;
      const slides = Array.from(this.track.children);
      if (!slides.length) return;
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let index = 0;
      let best = Infinity;
      slides.forEach((slide, i) => {
        const centre = slide.offsetLeft - this.track.offsetLeft + slide.clientWidth / 2;
        const delta = Math.abs(centre - mid);
        if (delta < best) {
          best = delta;
          index = i;
        }
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
    });
  };

  #raf = 0;
}

if (!customElements.get('swisa-carousel')) {
  customElements.define('swisa-carousel', SwisaCarousel);
}
